import { render, staticRenderFns } from "./w-tag.vue?vue&type=template&id=890d87ee&scoped=true&"
import script from "./w-tag.vue?vue&type=script&lang=js&"
export * from "./w-tag.vue?vue&type=script&lang=js&"
import style0 from "./w-tag.vue?vue&type=style&index=0&id=890d87ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890d87ee",
  null
  
)

export default component.exports